import axios from 'axios';

const API_URL = 'https://sanhangsalegiare.herokuapp.com';

export const fetchPosts = (payload) => axios.get(`${API_URL}/posts/latest/${payload.size}?title=${payload.title}`);

export const getPostDetail = (postId) => axios.get(`${API_URL}/posts/post-by-id/${postId}`);

export const getRelatedPosts = (payload) => axios.get(`${API_URL}/posts/4-latest-related?type=${payload.type}&title=${payload.title}`);

export const getHighLightPosts = () => axios.get(`${API_URL}/posts/latest/highlight`);

export const getPostsApiService = ({ pageNumber, pageSize }) => axios.get(`${API_URL}/posts?pageNumber=${pageNumber}&pageSize=${pageSize}`);

export const searchPostsApiService = ({ searchBy, pageNumber, pageSize }) => axios.get(`${API_URL}/posts/search/${searchBy}?pageNumber=${pageNumber}&pageSize=${pageSize}`);

export const createPost = (payload) => axios.post(`${API_URL}/posts`, payload);

export const updatePost = (payload) => axios.put(`${API_URL}/posts`, payload);

export const deletePost = (payload) => axios.delete(`${API_URL}/posts/${payload}`);

export const crawlData = (id) => axios.get(`${API_URL}/crawl-data/get/${id}`);